import { render, staticRenderFns } from "./footermenu.vue?vue&type=template&id=4295f1fd&scoped=true&"
import script from "./footermenu.vue?vue&type=script&lang=js&"
export * from "./footermenu.vue?vue&type=script&lang=js&"
import style0 from "./footermenu.vue?vue&type=style&index=0&id=4295f1fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4295f1fd",
  null
  
)

export default component.exports